/**
 * Por quanto multiplicar o bonus de UMA linha no custo estimado, espelhando o
 * CASE de FuncaoCalculaBonus (database/procedures/campanha-apuracao.sql):
 *
 *   WHEN v_id_tipo_pagamento = 1 AND v_base_calculo = 'P' THEN 0
 *   WHEN v_id_tipo_pagamento = 1 THEN v_bonus_faixa * v_realizado
 *   WHEN v_id_tipo_pagamento = 2 THEN v_bonus_faixa
 *
 * - Valor Fixo (tipoPagamento != 1): 1 -- o bonus e pago uma vez.
 * - Percentual ('P') no Por Unidade: 0 -- o percentual qualifica e nao paga;
 *   quem paga e o indicador de quantidade da mesma meta.
 * - Ocorrencia ('O') no Por Unidade: 1 -- estimativa acordada de uma unidade
 *   qualificada por colaborador, sem multiplicar pela metrica.
 * - Resto: a quantidade da linha (valor_meta na meta fixa, qtde_ate da maior
 *   faixa na progressiva).
 *
 * baseCalculo e tipoApuracao existem so em conteudo de indicador; nos demais
 * conteudos vem nulos e cai no multiplicador por quantidade -- igual a
 * procedure, onde v_base_calculo fica NULL fora do laco de indicadores.
 *
 * Sao atributos DE LINHA, nao da meta: uma meta pode ter margem ('P') junto de
 * quantidade ('Q'), e cada indicador entra no custo com o seu multiplicador.
 *
 * O parseFloat e obrigatorio: a API devolve NUMBER do Oracle como string.
 */
const normalizar = valor =>
  String(valor === null || valor === undefined ? "" : valor)
    .trim()
    .toUpperCase();

export default function multiplicadorBonus({
  tipoPagamento,
  tipoApuracao,
  baseCalculo,
  quantidade
} = {}) {
  if (Number(tipoPagamento) !== 1) return 1;
  if (normalizar(baseCalculo) === "P") return 0;
  if (normalizar(tipoApuracao) === "O") return 1;
  return parseFloat(quantidade) || 0;
}
